import { FIGHT_FADE_S } from "./FIGHT_FADE_S";
import type { DeathMark } from "./MapScene";

// Прозрачность крестика смерти в момент `t`. Крестика нет раньше самой смерти — ни в «за
// весь матч», ни в «до момента». Твои смерти с момента смерти остаются до конца матча
// (копятся), чужие живут до конца драки и тают.
export const deathMarkOpacity = (mark: DeathMark, t: number): number => {
  if (t < mark.t) {
    return 0;
  }
  if (mark.kind === "me") {
    return 1;
  }
  if (t >= mark.until) {
    return 0;
  }
  return Math.min(1, (mark.until - t) / FIGHT_FADE_S + 0.15);
};
